module.exports = __webpack_public_path__ + "img/FAVICON-EK-candy.189f2ed7.svg";